import { useRollbar as useRollbarLib } from '@rollbar/react';
import { useMemo } from 'react';

import { handleRollbarLog } from '@/utils/rollbar';

export default function useRollbar() {
  const rollbar = useRollbarLib();

  return useMemo(
    () => ({
      log: handleRollbarLog('log', rollbar),
      error: handleRollbarLog('error', rollbar),
      info: handleRollbarLog('info', rollbar),
      debug: handleRollbarLog('debug', rollbar),
      critical: handleRollbarLog('critical', rollbar),
      warn: handleRollbarLog('warn', rollbar),
      warning: handleRollbarLog('warning', rollbar),
    }),
    [rollbar],
  );
}
